import { render, staticRenderFns } from "./AboutDesc.vue?vue&type=template&id=9a699f34&scoped=true&"
import script from "./AboutDesc.vue?vue&type=script&lang=js&"
export * from "./AboutDesc.vue?vue&type=script&lang=js&"
import style0 from "./AboutDesc.vue?vue&type=style&index=0&id=9a699f34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a699f34",
  null
  
)

export default component.exports